import { StyleSheet } from 'react-native';
import { tokens } from '@airtel/air-design-system';
export var getOverViewCardWidgetStyles = () => {
  return StyleSheet.create({
    infoTagsContainerStyle: {
      flexDirection: 'row',
      marginBottom: tokens.spacing.SPACING_12,
      flexWrap: 'wrap'
    },
    horizontalPadding16: {
      paddingHorizontal: tokens.spacing.SPACING_16
    },
    marginBottom16: {
      marginBottom: tokens.spacing.SPACING_16
    },
    cardSectionTitleStyle: {
      marginBottom: tokens.spacing.SPACING_12
    },
    carouselImageItem: {
      height: 152
    },
    headerContainerStyle: {
      paddingHorizontal: 16,
      paddingTop: 16
    },
    footerContainerStyle: {
      paddingHorizontal: 16
    },
    dotIndicatorStyle: {
      borderRadius: 8,
      width: 8,
      height: 8
    }
  });
};